module.exports = __webpack_public_path__ + "static/media/20210409_195420_712_IMG_0101.53ef156c.jpg";